export default __webpack_public_path__ + "static/media/mot.01e20774.png";